// Source: app/scripts/controllers/edit-customs-warehouse-case.js
Auction.controller('EditCustomsWarehouseCaseController', [
  '$scope',
  '$filter',
  '$routeParams',
  '$location',
  '$route',
  '$timeout',
  'toaster',
  'crudService',
  '$modal',
  'Downloader',
  'Messages',
  'SimplifiedProcedureValidation',
  'ModalScrollLock',
  'CustomsWarehouseFormHelpers',
  function ($scope, $filter, $routeParams, $location, $route, $timeout, toaster, crudService, $modal, Downloader, Messages, SimplifiedProcedureValidation, ModalScrollLock, CustomsWarehouseFormHelpers) {
    var caseService = crudService('cases', {
      'getCase': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/customs_warehouse_cases/:id'
      },
      'editCustomsWarehouseCase': {
        method: 'POST',
        url: '/data/rest/customs_warehouse_cases/edit_customs_warehouse_case'
      },
      'editCustomsWarehouse': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/customs_warehouse/edit_customs_warehouse'
      },
      'getPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/by_case_id/:id'
      },
      'getOutgoingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_outgoing_documents_for_case_id/:id'
      },
      'getIncomingPortalDocumentsForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/portal_documents/get_incoming_documents_for_case_id/:id'
      },
      'editPortalDocumentMetadata': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_documents/edit_portal_document'
      },
      'deletePortalDocument': {
        method: 'DELETE',
        url: '/data/rest/portal_documents/:id'
      },
      'getForumMessagesForCase': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/forum/get_forum_messages/:id'
      },
      'saveForumMessage': {
        method: 'POST',
        isArray: false,
        url: '/data/rest/forum_messages'
      },
      'submitCustomsWarehouseCase': {
        method: 'POST',
        url: '/data/rest/customs_warehouse_cases/submit_customs_warehouse_case'
      },
      'getCustomsWarehouseById': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/customs_warehouse/by_customs_warehouse_case_id/:id'
      },
      'getDocumentTypeByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/portal_document_types/by_code'
      }
    });

    var customsWarehouseGoodsService = crudService('customs_warehouse_goods', {
      'getCustomsWarehouseGoodsForCaseId': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/customs_warehouse_goods/by_customs_warehouse_case_id/:id'
      },
      'saveCustomsWarehouseGoods': {
        method: 'POST',
        isArray: true,
        url: '/data/rest/customs_warehouse_goods/save_goods'
      },
      'deleteCustomsWarehouseGood': {
        method: 'DELETE',
        url: '/data/rest/customs_warehouse_goods/:id'
      }
    });

    var customsWarehouseLocationService = crudService('customs_warehouse_locations', {
      'getCustomsWarehouseLocationsForCaseId': {
        method: 'GET',
        isArray: true,
        url: '/data/rest/customs_warehouse_locations/by_customs_warehouse_case_id/:id'
      }
    });

    var authorizationCaseService = crudService('authorization_cases', {
      'findTariffByCode': {
        method: 'GET',
        isArray: false,
        url: '/data/rest/tariffs/by_code'
      }
    });

    // var iprRightsService = crudService('ipr_rights', {
    //   'getIprRightsForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/ipr_rights/by_ipr_case_id/:id'
    //   },
    //   'addIprRightsToIPRCase': {
    //     method: 'POST',
    //     url: '/data/rest/ipr_rights/add_ipr_rights_to_ipr_case'
    //   },
    //   'deleteIprRights': {
    //     method: 'DELETE',
    //     url: '/data/rest/ipr_rights/:id'
    //   },
    //   'saveIprRights': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/ipr_rights/save_rights'
    //   }
    // });

    // var iprGoodsService = crudService('ipr_goods', {
    //   'getIprGoodsForCaseId': {
    //     method: 'GET',
    //     isArray: true,
    //     url: '/data/rest/ipr_goods/by_ipr_case_id/:id'
    //   },
    //   'addIprGoodsToIPRCase': {
    //     method: 'POST',
    //     url: '/data/rest/ipr_goods/add_ipr_goods_to_ipr_case'
    //   },
    //   'deleteIprGoods': {
    //     method: 'DELETE',
    //     url: '/data/rest/ipr_goods/:id'
    //   },
    //   'saveIprGoods': {
    //     method: 'POST',
    //     isArray: 'true',
    //     url: '/data/rest/ipr_goods/save_goods'
    //   }
    // });

    var forumService = crudService('forum', {
        'getForumMessagesForCase': {
          method: 'GET',
          isArray: true,
          url: '/data/rest/forum/get_forum_messages/:id'
        },
        'saveForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        },
        'submitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages/submit_forum_message'
        },
        'deleteForumMessage': {
          method: 'DELETE',
          isArray: false,
          url: '/data/rest/forum_messages/:id'
        },
        'saveAndSubmitForumMessage': {
          method: 'POST',
          isArray: false,
          url: '/data/rest/forum_messages'
        }

      }
    );
    if ($routeParams && $routeParams.recordsTab) {
      $scope.recordsTab = $routeParams.recordsTab;
    }

    $scope.activateTab = function (rt) {
      var search = {
        recordsTab: rt
      };

     $scope.recordsTab = rt;
    };

    if ($routeParams && $routeParams.recordsDocumentTab) {
      $scope.recordsDocumentTab = $routeParams.recordsDocumentTab;
    }

    $scope.activateDocumentTab = function (rt) {
      var search = {
        recordsDocumentTab: rt
      };
      $scope.recordsDocumentTab = rt;
    };


    function loadCustomsWarehouseData(caseId) {
      caseService.getCustomsWarehouseById({id: caseId}, function (data) {
        $scope.customsWarehouse = data || {};
        if (!$scope.customsWarehouseCaseEntity) {
          $scope.customsWarehouseCaseEntity = {};
        }
        $scope.customsWarehouseCaseEntity.customsWarehouse = $scope.customsWarehouse;
      });
      customsWarehouseGoodsService.getCustomsWarehouseGoodsForCaseId({id: caseId}, function (data) {
        if (!$scope.customsWarehouseCaseEntity) {
          $scope.customsWarehouseCaseEntity = {};
        }
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = data || [];
      });
      customsWarehouseLocationService.getCustomsWarehouseLocationsForCaseId({id: caseId}, function (data) {
        if (!$scope.customsWarehouseCaseEntity) {
          $scope.customsWarehouseCaseEntity = {};
        }
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = data || [];
      });
    }

    function initEntity() {
      $scope.editingRightIndex = -1;
      $scope.editingGoodIndex = -1;
      var portalCase;
      caseService.getCase({id: $routeParams.id}, function (data) {

        portalCase = data;
        if(portalCase.caseStatus != 'DRAFT' && portalCase.caseStatus != 'RETURNED_FOR_CORRECTIONS'){
          $scope.viewCustomsWarehouseCase(portalCase.id);
        }
        $scope.allowEdit = true;
        $scope.entity = {};
        $scope.entity.portalCase = portalCase;
        $scope.forum = portalCase.forum;
        $scope.newForumMessage = {};
        $scope.authorizationTariff = {};
        $scope.foundAuthorizationTafiff = "";
        $scope.customsWarehouse = {};
        $scope.customsWarehouseCase = portalCase;
        $scope.customsWarehouseCaseEntity = {};
        $scope.customsWarehouseCaseEntity.customsWarehouse = $scope.customsWarehouse;
        //$scope.customsWarehouseCaseEntity.iprRightsList = [];
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
        $scope.onEditRight = false;
        $scope.onEditGood = false;
        $scope.chosenDocument = {};
        $scope.portalDocument = {};
        if (portalCase.aboutIndividual) {
          $scope.entity.forCompany = 0;
          $scope.entity.forIndividual = 1;
          $scope.forCompany = 0;
          $scope.forIndividual = 1;
          $scope.individual = portalCase.aboutIndividual;
        } else {
          $scope.entity.forCompany = 1;
          $scope.entity.forIndividual = 0;
          $scope.forCompany = 1;
          $scope.forIndividual = 0;
          $scope.company = portalCase.aboutCompany;

        }
        $scope.activateTab(1);
        loadCustomsWarehouseData($scope.entity.portalCase.id);
        caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
          $scope.outgoingDocumentList = data;
          $scope.activateDocumentTab(1);
          caseService.getIncomingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.incomingDocumentList = data;
            caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
              $scope.forumMessagesList = data;
            });
          });
        });
      });


    }


    initEntity();


    $scope.editCase = function (portalCase) {
      caseService.editCustomsWarehouseCase(portalCase, function (data) {
        $scope.entity.portalCase = portalCase;
        Messages.saved();
      })
    };


    $scope.downloadDocument = function () {
      if ($scope.chosenDocument.id) {
        Downloader.download('/data/rest/portal_attachments/get/' + $scope.chosenDocument.id);
      }
    };

    $scope.saveChosenDocumentMetadata = function () {
      if ($scope.chosenDocument.id) {
        caseService.editPortalDocumentMetadata(
          {
            id:  $scope.chosenDocument.id,
            description:  $scope.chosenDocument.description,
            typeId: $scope.chosenDocument.documentType.id
          }, function (data) {
            $scope.chosenDocument = data;
            Messages.saved();
          })
      }
    };


    $scope.outgoingDocumentsIndeks = -1;
    $scope.incomingDocumentsIndeks = -1;
    $scope.chooseOutgoingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.outgoingDocumentsIndeks = index;
      $scope.incomingDocumentsIndeks = -1;
    };
    $scope.chooseIncomingDocument = function (portalDocument, index) {
      $scope.chosenDocument = portalDocument;
      $scope.incomingDocumentsIndeks = index;
      $scope.outgoingDocumentsIndeks = -1;
    };


    $scope.modalAddOrEditCustomsWarehouseRequiredDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_customs_warehouse_required_document.html',
      show: false
    });

    $scope.modalAddOrEditCaseDocument = $modal({
      scope: $scope,
      template: 'forms/modals/add_or_edit_case_document.html',
      show: false
    });

    $scope.modalSubmitCaseConfirm = $modal({
      scope: $scope,
      template: 'templates/forum-form.tpl.html',
      contentTemplate: 'forms/modals/submit_case_confirm.html',
      show: false
    });

    var rightScope = $scope.$new(true);
    var addOrEditRightDialog = $modal({
      scope: rightScope,
      template: 'forms/add_or_edit_ipr_rights.html',
      show: false,
      windowClass: 'my-small-modal'
    });

    rightScope.$watch('rightEntity', function (newVal) {
      if (!newVal) return;

      var selectedGoods = [];

      // Поминуваме низ сите 45 полиња од HTML-от (referredItem1 до referredItem45)
      for (var i = 1; i <= 45; i++) {
        var propertyName = 'referredItem' + i;
        // Ако чекбоксот е штиклиран во rightEntity
        if (newVal[propertyName] === true) {
          selectedGoods.push(i);
        }
      }

      // Автоматски го пополнуваме referredList со броевите (пр. "1, 2, 5")
      // Ова веднаш ќе се рефлектира во input полето во HTML-от
      rightScope.rightEntity.referredList = selectedGoods.join(', ');

    }, true);

    $scope.modalAddOrEditWarehouseGood = $modal({
      scope: $scope,
      template: 'forms/add_or_edit_warehouse_goods.html',
      show: false,
      windowClass: 'my-large-modal'
    });

    $scope.modalAddOrEditWarehouseLocation = $modal({
      scope: $scope,
      template: 'forms/add_or_edit_warehouse_location.html',
      show: false,
      windowClass: 'my-large-modal'
    });

    ModalScrollLock.bindScope($scope);

    $scope.ensureCustomsWarehouseGoodsList = function () {
      if (!$scope.customsWarehouseCaseEntity) {
        $scope.customsWarehouseCaseEntity = {};
      }
      if (!$scope.customsWarehouseCaseEntity.customsWarehouseGoodsList) {
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = [];
      }
    };

    $scope.ensureCustomsWarehouseLocationList = function () {
      if (!$scope.customsWarehouseCaseEntity) {
        $scope.customsWarehouseCaseEntity = {};
      }
      if (!$scope.customsWarehouseCaseEntity.customsWarehouseLocationList) {
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = [];
      }
    };

    $scope.searchTariffByCodeForWarehouseGood = function (code) {
      authorizationCaseService.findTariffByCode({code: code}, function (data) {
        if (data.id) {
          $scope.warehouseGoodEntity.tariff = data;
          $scope.warehouseGoodEntity.tariffCode = code;
          $scope.warehouseGoodEntity.tariffDescription = data.labelSQ;
          $scope.foundWarehouseTariffMessage = '';
        } else {
          $scope.warehouseGoodEntity.tariff = null;
          $scope.warehouseGoodEntity.tariffDescription = null;
          $scope.foundWarehouseTariffMessage = 'portal.tariff_not_found';
        }
      });
    };

    $scope.saveWarehouseGoodFromModal = function () {
      var entity = $scope.warehouseGoodEntity;
      if (!entity.tariff || !entity.tariff.id) {
        Messages.error('portal.invalid_tariff');
        return;
      }

      var good = {
        tariffCode: entity.tariffCode,
        tariffDescription: entity.tariffDescription || entity.tariff.labelSQ,
        quantity: entity.quantity,
        value: entity.value,
        tariff: entity.tariff
      };

      $scope.ensureCustomsWarehouseGoodsList();

      if ($scope.onEditWarehouseGood && $scope.editingWarehouseGoodIndex !== -1) {
        good.id = $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[$scope.editingWarehouseGoodIndex].id;
        angular.copy(good, $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[$scope.editingWarehouseGoodIndex]);
      } else {
        $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.push(good);
      }

      Messages.saved();
      $scope.modalAddOrEditWarehouseGood.hide();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
    };

    $scope.cancelWarehouseGoodModal = function () {
      $scope.modalAddOrEditWarehouseGood.hide();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
    };

    $scope.showAddNewDocumentForm = function () {
      $scope.portalDocument = {};
      $scope.modalAddOrEditCaseDocument.show();
    };

    $scope.changeAttachmentForDocument = function () {
      if ($scope.chosenDocument.id) {
        $scope.portalDocument = $scope.chosenDocument;
        $scope.modalAddOrEditCustomsWarehouseRequiredDocument.show();
      }
    };

    $scope.savePortalDocument = function () {
      caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
        $scope.outgoingDocumentList = data;
      });
      $scope.modalAddOrEditCaseDocument.hide();

      $scope.portalDocument = {};

    };


    $scope.showAddNewCustomsWarehouseRequiredDocForm = function () {
        caseService.getDocumentTypeByCode({code: 'CUSTOMS_WAREHOUSE_REQUIRED'}, function (data) {
          $scope.portalDocument = {};
          $scope.portalDocument.documentType = data;
          $scope.modalAddOrEditCustomsWarehouseRequiredDocument.show();
        });

    };


    $scope.deletePortalDocument = function () {
      if ($scope.chosenDocument.id) {
        caseService.deletePortalDocument({id: $scope.chosenDocument.id}, function () {
          caseService.getOutgoingPortalDocumentsForCase({id: $scope.entity.portalCase.id}, function (data) {
            $scope.outgoingDocumentList = data;
            Messages.deleted();
            $scope.chosenDocument = {};
          });
        })
      }

    };

    $scope.saveForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      caseService.saveForumMessage(forumMessage, function (data) {
        caseService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })

    };


    $scope.submitForumMessage = function (forumMessage) {
      forumService.submitForumMessage(forumMessage.id, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };


    $scope.saveAndSubmitForumMessage = function (forumMessage) {
      forumMessage.forum = $scope.forum;
      forumMessage.bodySR = forumMessage.bodySQ;
      forumMessage.bodyEN = forumMessage.bodySQ;
      forumService.saveForumMessage(forumMessage, function (data) {
        $scope.forumMessage2 = data;
        forumService.submitForumMessage(data.id, function (data) {
          forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
            $scope.forumMessagesList = data;
            $scope.newForumMessage = {};
          });
        });
      });
    };

    $scope.deleteForumMessage = function (forumMessage) {
      forumService.deleteForumMessage({id: forumMessage.id}, function (data) {
        forumService.getForumMessagesForCase({id: $scope.forum.id}, function (data) {
          $scope.forumMessagesList = data;
          $scope.newForumMessage = {};
        });
      })
    };

    $scope.openSubmitForm = function(portalCase){
      $scope.portalCase = portalCase;
      $scope.modalSubmitCaseConfirm.show();
    };

    $scope.submitPortalCase = function (id) {

      caseService.submitCustomsWarehouseCase(id, function (data) {
        Messages.saved();
        $scope.modalSubmitCaseConfirm.hide();
        ModalScrollLock.release();
        $location.path("/web_portal/web_portal_home_page/view_customs_warehouse_case/" + id);
        $timeout(function () {
          ModalScrollLock.release();
          $route.reload();
        });
      });

    };

    // $scope.addNewIprRight = function () {
    //   $scope.onEditRight = false;
    //   $scope.editingRightIndex = -1;
    //   rightScope.rightEntity = {};
    //   addOrEditRightDialog.show();
    // }
    //
    $scope.addNewCustomsWarehouseGood = function () {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseGoodsList();
      $scope.onEditWarehouseGood = false;
      $scope.editingWarehouseGoodIndex = -1;
      $scope.warehouseGoodEntity = {};
      $scope.foundWarehouseTariffMessage = '';
      $scope.modalAddOrEditWarehouseGood.show();
    };

    $scope.editCustomsWarehouseGood = function (index) {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseGoodsList();
      $scope.onEditWarehouseGood = true;
      $scope.editingWarehouseGoodIndex = index;
      $scope.warehouseGoodEntity = angular.copy($scope.customsWarehouseCaseEntity.customsWarehouseGoodsList[index]);
      $scope.foundWarehouseTariffMessage = '';
      if ($scope.warehouseGoodEntity.tariffCode) {
        authorizationCaseService.findTariffByCode({code: $scope.warehouseGoodEntity.tariffCode}, function (data) {
          if (data.id) {
            $scope.warehouseGoodEntity.tariff = data;
          }
        });
      }
      $scope.modalAddOrEditWarehouseGood.show();
    };

    $scope.removeCustomsWarehouseGoods = function (index) {
      $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList.splice(index, 1);
    };

    $scope.prepareCustomsWarehouseGoodsForSave = function () {
      return ($scope.customsWarehouseCaseEntity.customsWarehouseGoodsList || []).map(function (good) {
        return {
          id: good.id,
          tariffCode: good.tariffCode,
          tariffDescription: good.tariffDescription,
          quantity: good.quantity,
          value: good.value
        };
      });
    };

    $scope.addNewCustomsWarehouseLocation = function () {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseLocationList();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
      $scope.modalAddOrEditWarehouseLocation.show();
    };

    $scope.editCustomsWarehouseLocation = function (index) {
      ModalScrollLock.capture();
      $scope.ensureCustomsWarehouseLocationList();
      $scope.onEditWarehouseLocation = true;
      $scope.editingWarehouseLocationIndex = index;
      $scope.warehouseLocationEntity = angular.copy($scope.customsWarehouseCaseEntity.customsWarehouseLocationList[index]);
      $scope.modalAddOrEditWarehouseLocation.show();
    };

    $scope.removeCustomsWarehouseLocation = function (index) {
      $scope.customsWarehouseCaseEntity.customsWarehouseLocationList.splice(index, 1);
    };

    $scope.saveWarehouseLocationFromModal = function () {
      var entity = $scope.warehouseLocationEntity;
      var location = {
        address: entity.address,
        streetNumber: entity.streetNumber,
        place: entity.place
      };

      $scope.ensureCustomsWarehouseLocationList();

      if ($scope.onEditWarehouseLocation && $scope.editingWarehouseLocationIndex !== -1) {
        location.id = $scope.customsWarehouseCaseEntity.customsWarehouseLocationList[$scope.editingWarehouseLocationIndex].id;
        angular.copy(location, $scope.customsWarehouseCaseEntity.customsWarehouseLocationList[$scope.editingWarehouseLocationIndex]);
      } else {
        $scope.customsWarehouseCaseEntity.customsWarehouseLocationList.push(location);
      }

      Messages.saved();
      $scope.modalAddOrEditWarehouseLocation.hide();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
    };

    $scope.cancelWarehouseLocationModal = function () {
      $scope.modalAddOrEditWarehouseLocation.hide();
      $scope.onEditWarehouseLocation = false;
      $scope.editingWarehouseLocationIndex = -1;
      $scope.warehouseLocationEntity = {};
    };

    $scope.prepareCustomsWarehouseLocationsForSave = function () {
      return ($scope.customsWarehouseCaseEntity.customsWarehouseLocationList || []).map(function (location) {
        return {
          id: location.id,
          address: location.address,
          streetNumber: location.streetNumber,
          place: location.place
        };
      });
    };

    // rightScope.ok = function () {
    //   if ($scope.onEditRight===false) {
    //     $scope.iprCaseEntity.iprRightsList.push(rightScope.rightEntity);
    //     Messages.saved();
    //   } else {
    //     if ($scope.editingRightIndex !== -1) {
    //       angular.copy(rightScope.rightEntity, $scope.iprCaseEntity.iprRightsList[$scope.editingRightIndex]);
    //       Messages.saved();
    //     } else {
    //       Messages.error('portal.error');
    //     }
    //   }
    //   addOrEditRightDialog.hide();
    //   $scope.onEditRight=false;
    //
    // };


    // rightScope.cancel = function () {
    //   addOrEditRightDialog.hide();
    // };

    // $scope.addIPRRights = function (iprRights) {
    //   var counter = $scope.iprRights.length;
    //
    //   if(iprRights.rightNumber){
    //     $scope.iprRightsList.splice(iprRights.itemNumber-1, 1);
    //   }else{
    //     iprRights.rightNumber = $scope.iprRightsList.length+1;
    //   }
    //   $scope.iprRightsList.splice(iprRights.rightNumber-1, 0, iprRights);
    //   $scope.iprRights = {};
    // };
    //
    // $scope.removeIPRRights = function (item) {
    //   var index = item;
    //   $scope.iprRightsList.splice(index, 1);
    // };
    //
    // $scope.addIPRGoods = function (iprGoods) {
    //   var counter = $scope.iprGoods.length;
    //
    //   if(iprGoods.rightNumber){
    //     $scope.iprGoodsList.splice(iprGoods.itemNumber-1, 1);
    //   }else{
    //     iprGoods.rightNumber = $scope.iprGoodsList.length+1;
    //   }
    //   $scope.iprGoodsList.splice(iprGoods.rightNumber-1, 0, iprGoods);
    //   $scope.iprGoods = {};
    // };
    //
    // $scope.removeIPRGoods = function (item) {
    //   var index = item;
    //   $scope.iprGoodsList.splice(index, 1);
    // };
    //
    //
    // $scope.editIprRight = function (item) {
    //   $scope.onEditRight=true;
    //   var index = item;
    //   $scope.editingRightIndex = index;
    //   rightScope.rightEntity = angular.copy($scope.iprRightsList[index]);
    //   addOrEditRightDialog.show();
    // };
    //
    // $scope.editIprGood = function (item) {
    //   $scope.onEditGood=true;
    //   var index = item;
    //   $scope.editingGoodIndex = index;
    //   goodScope.goodEntity = angular.copy($scope.iprGoodsList[index]);
    //   addOrEditGoodDialog.show();
    // };

    $scope.editCustomsWarehouse = function (customsWarehouse) {
      if (!SimplifiedProcedureValidation.validateCustomsWarehouseAndNotify(customsWarehouse)) {
        return;
      }

      $scope.ensureCustomsWarehouseGoodsList();
      $scope.ensureCustomsWarehouseLocationList();

      $scope.entityForUpdate = {};
      $scope.entityForUpdate.customsWarehouse = customsWarehouse;
      if ($scope.entity.portalCase && $scope.entity.portalCase.id) {
        $scope.entityForUpdate.customsWarehouse.customsWarehouseCase = {id: $scope.entity.portalCase.id};
      }
      $scope.entityForUpdate.customsWarehouseGoodsList = $scope.prepareCustomsWarehouseGoodsForSave();
      $scope.entityForUpdate.customsWarehouseLocationList = $scope.prepareCustomsWarehouseLocationsForSave();

      caseService.editCustomsWarehouse($scope.entityForUpdate, function (data) {
        $scope.customsWarehouse = data;
        customsWarehouseGoodsService.getCustomsWarehouseGoodsForCaseId({id: $scope.entity.portalCase.id}, function (goods) {
          $scope.customsWarehouseCaseEntity.customsWarehouseGoodsList = goods || [];
          customsWarehouseLocationService.getCustomsWarehouseLocationsForCaseId({id: $scope.entity.portalCase.id}, function (locations) {
            $scope.customsWarehouseCaseEntity.customsWarehouseLocationList = locations || [];
            Messages.saved();
            $scope.activateTab(1);
          });
        });
      });

    };

    $scope.onEntryDeclarationOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onEntryDeclarationOptionChange($scope, selectedField);
    };

    $scope.onDischargeDeclarationOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onDischargeDeclarationOptionChange($scope, selectedField);
    };

    $scope.onTransferInfoOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onTransferInfoOptionChange($scope, selectedField);
    };

    $scope.onWarehouseTypeOptionChange = function (selectedField) {
      CustomsWarehouseFormHelpers.onWarehouseTypeOptionChange($scope, selectedField);
    };

    $scope.viewCustomsWarehouseCase = function (id) {
      $location.path("/web_portal/web_portal_home_page/view_customs_warehouse_case/" + id);
    };


  }
]);
